import { apiClient } from "../lib/api";

export const applicationApi = {
  create: () => apiClient.post("/applications"),
  list: (status) => apiClient.get("/applications", { params: status ? { status } : {} }),
  get: (id) => apiClient.get(`/applications/${id}`),
  updateStep: (id, stepKey, data) => apiClient.patch(`/applications/${id}`, { [stepKey]: data }),
  checkDuplicates: (id) => apiClient.post(`/applications/${id}/duplicate-check`),
  resolveDuplicate: (id, resolution, reason) => apiClient.post(`/applications/${id}/duplicate-resolution`, { resolution, reason }),
  submit: (id) => apiClient.post(`/applications/${id}/submit`),
  requestCorrection: (id, reason) => apiClient.post(`/applications/${id}/request-correction`, { reason }),
  reject: (id, reason) => apiClient.post(`/applications/${id}/reject`, { reason }),
  withdraw: (id, reason) => apiClient.post(`/applications/${id}/withdraw`, { reason }),
  override: (id, reason) => apiClient.post(`/applications/${id}/override`, { reason }),
  approveAndConvert: (id) => apiClient.post(`/applications/${id}/approve-and-convert`),
};
